import { useEffect } from "react"

function RedirectToFindMyDevice() {
    useEffect(() => {
        window.location.replace('https://portal.wmt.us-east-1.aws.sysco.net/FindMyDevice');
    }, []);
}

export default RedirectToFindMyDevice;